<div class="wrap margin-large-top-res">

    <div uk-grid class="uk-grid-small remove-grid-ml-pl">
        <div class="uk-width-1-2@s uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="status === 0" (click)="changeStatus(0)">
                    Tout
                </button>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="status === 1" (click)="changeStatus(1)">
                    À venir
                </button>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="status === 2" (click)="changeStatus(2)">
                    En cours
                </button>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="status === 3" (click)="changeStatus(3)">
                    Clôturée
                </button>
            </div>
        </div>

        <div class="uk-width-1-2 uk-width-1-4@s uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <app-datepicker [(date)]="dateStart" (dateChange)="onDateChange(true, $event)"></app-datepicker>
                <app-datepicker [(date)]="dateEnd" (dateChange)="onDateChange(false, $event)"></app-datepicker>
            </div>
        </div>

        <div class="uk-width-1-4@m uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <input class="search-bar" type="text" [(ngModel)]="search" placeholder="Rechercher"
                (ngModelChange)="onSearchChange($event)" style="width: calc(100% - 20px);">
                <span class="uk-form-icon uk-form-icon-flip" style="right: 10px;">
                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user"/>
                </span>
            </div>
        </div>

        <div class="uk-width-1-1 uk-margin-top">
            <button class="button bold uk-display-inline-block uk-float-right" (click)="exportDataAsXLSX()" type="button">
                <span *ngIf="excelLoading === false">
                    <span class="vertical-align-middle">Export</span>
                    <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user" class="uk-margin-left"/> 
                </span>
                <span *ngIf="excelLoading === true">
                    <div uk-spinner class="loading-small-button"></div>
                </span>
            </button>
        </div>
    </div>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Vous n'avez pas de réservations pour cette période.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false">

        <div *ngIf="comeUp.length > 0" class="title bold uk-margin uk-margin-large-top">Réservations à venir</div>

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <div uk-grid *ngFor="let reservation of comeUp; let i = index"
            class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer" [routerLink]="['/reservation/informations', reservation.Id]">
                <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center" style="font-size: 17px;">
                    {{ reservation.Vehicle }}
                </div>
                <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase" style="font-size: 13px;">
                    {{ reservation.User }}
                </div>
                <div class="uk-visible@m uk-width-expand item-column"></div>

                <div class="uk-visible@s uk-width-1-12 item-column" *ngIf="reservation.demo === true" style="font-size: 13px;">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span> 
                    <!-- uk-display-inline-block -->
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column" style="font-size: 15px;">
                    #{{ reservation.Code }}
                </div>
            </div>
        </div>

        <div class="title bold uk-margin uk-margin-large-top">Réservations démarrées</div>

        <!-- <button class="button bold button-align uk-display-inline-block uk-float-right uk-margin-left uk-margin-bottom" type="button" uk-toggle="target: #information-reservation">zeezrzrzerze rez ez ze r</button> -->
        
        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <div uk-grid *ngFor="let reservation of inProgress; let i = index"
            class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer" uk-toggle="target: #information-reservation">
                <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center" style="font-size: 17px;">
                    {{ reservation.Vehicle }}
                </div>
                <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase" style="font-size: 13px;">
                    {{ reservation.User }}
                </div>
                <div class="uk-visible@s uk-width-expand item-column"></div>
                <div class="uk-visible@s uk-width-1-12 item-column" *ngIf="reservation.demo === true" style="font-size: 13px;">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column" style="font-size: 15px;">
                    #{{ reservation.Code }}
                </div>
            </div>
        </div>

        <div *ngIf="finished.length > 0" class="title bold uk-margin uk-margin-large-top">Réservations clôturées</div>

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <a uk-grid *ngFor="let reservation of finished; let i = index" href="#"
            class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer" [routerLink]="['/reservation/informations', reservation.Id]">
                <div class="uk-width-1-7@s uk-width-1-3  item-column bold uk-position-relative" style="font-size: 17px;">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3  item-column light uk-text-uppercase uk-text-center" style="font-size: 17px;">
                    {{ reservation.Vehicle }}
                </div>
                <div class="uk-width-1-5@s uk-width-1-3  item-column bold uk-text-uppercase" style="font-size: 13px;">
                    {{ reservation.User }}
                </div>
                <div class="uk-visible@s uk-width-expand item-column"></div>
                <div class="uk-visible@s uk-width-1-12 item-column bold" *ngIf="reservation.totalAmount > 0 && reservation.demo === false" style="font-size: 13px;">
                    {{ reservation.totalAmount.toFixed(2) }}€
                </div>
                <div class="uk-visible@m uk-width-1-12 item-column" *ngIf="reservation.demo === true" style="font-size: 13px;">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>

                <div class="uk-visible@s uk-width-1-12 item-column" [class.color-green]="reservation.Status == 14" [class.color-orange]="reservation.Status == 13" style="font-size: 15px;">
                    #{{ reservation.Code }}
                </div>
            </a>
        </div>

        <div *ngIf="canceled.length > 0" class="title bold uk-margin uk-margin-large-top">Réservations annulées</div>

        <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
            <a uk-grid *ngFor="let reservation of canceled; let i = index" href="#"
            class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer" [routerLink]="['/reservation/informations', reservation.Id]">
                <div class="uk-width-1-7@s uk-width-1-3 item-column bold uk-position-relative" style="font-size: 17px;">
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateStart }}"></span>
                    </div>
                    <div class="uk-display-block">
                        <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true" shortened="true"></span>
                        <span class="uk-text-small uk-margin-small-left regular" hours="{{ reservation.ISODateEnd }}"></span>
                    </div>
                    <div class="separator"></div>
                </div>
                <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center" style="font-size: 17px;">
                    {{ reservation.Vehicle }}
                </div>
                <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase" style="font-size: 13px;">
                    {{ reservation.User }}
                </div>
                <div class="uk-width-expand item-column"></div>
                <div class="uk-visible@s uk-width-1-12 item-column bold" *ngIf="reservation.totalAmount > 0 && reservation.demo === false" style="font-size: 13px;">
                    {{ reservation.totalAmount.toFixed(2) }}€
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column" *ngIf="reservation.demo === true" style="font-size: 13px;">
                    <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                    <!-- uk-display-inline-block -->
                </div>
                <div class="uk-visible@s uk-width-1-12 item-column" style="font-size: 15px;">
                    #{{ reservation.Code }}
                </div>
            </a>
        </div>

        <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

        <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
            <div class="uk-position-center">
                <button [disabled]="currentPage === 1" class="uk-button button" (click)="prevPage()">Précédent</button>
                <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                    <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                    <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue" (click)="goPage(i + 1)">{{i + 1}}</div>
                </div>
                <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left" (click)="nextPage()">Suivant</button>
            </div>
        </div>

    </div>
</div>

<app-information-reservation
></app-information-reservation>